export const Colors = {
  background: '#fff',

  shadowColor: 'rgba(0, 0, 0, 0.25)',

  dark: '#2a2a2a',
  grayDark: '#757575',
  gray: '#d1d1d1',
  light: '#f5f5f5',

  primmaryLight: '#76aadd',
  primary: '#2e89e4',
  primaryDark: '#215c97',

  secondaryLight: '#f6928e',
  secondary: '#f43b35',
  secondaryDark: '#9a2622',

  primaryOpacity: 'rgba(47, 138, 228, 0.25)',
  secondaryOpacity: 'rgba(244, 59, 53, 0.25)'
};
